import React from "react";
  
const About = () => {
  return (
    <div className="container" >
      <h1>
        About us 
      </h1>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo, vero. Tempora necessitatibus explicabo minima reiciendis et eum voluptatem vitae natus, excepturi inventore doloremque magnam exercitationem dolor amet? Corrupti, odio! A corrupti aut sit ipsum, ex debitis officiis, recusandae repellendus alias labore earum vero eos laborum odio praesentium maiores exercitationem ducimus?
    </div>
  );
};
  
export default About;